import React, { Component, useRef, useState, useEffect } from 'react';
import {Link} from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import NavMenu from './NavMenu.js';
import * as utils from './Utils.js'

const registries = [
  {
    'company': 'Zola',
    'info': 'Items for our new home',
    'website': 'https://www.zola.com/registry/annaandchandlerapril25'
  }
]

const Registry = () => {
  useEffect(() => {
  }, [])

  return (
    <div className="Registry">
      <Helmet>
        <title>Registry</title>
        <meta
          name="description"
          content="Contribute to our Wedding Registy...Thank You!"
        />

        <meta property="og:title" content="Registry | Chandler & Anna" />
        <meta
          property="og:description"
          content="Contribute to our Wedding Registy...Thank You!"
        />
        <meta
          property="og:image"
          content="https://chandlerandanna.com/og/registry.jpg"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" />
        <meta property="og:url" content="https://chandlerandanna.com/registry" />

        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className='centered-box wedding-page-block'>
        <div className='wedding-centerpiece'>
          <p className='wedding-page-title'>Registry</p>
          <p className='wedding-page-info'>We are so grateful for any gifts you are able to offer!</p>
          <div className='things-to-do-container'>
            <div id="places" className='things-to-do-category'>
              <p className='things-to-do-category-title'>Registries</p>
              <div className='things-to-do-list'>
                <div key="cash" className='things-to-do-list-item'>
                  <p className='things-to-do-list-item-title'>Honeymoon + Future Fund</p>
                  <div className='things-to-do-list-item-links'>
                    If you prefer to pay cash online, you can contribute to our cash registry
                  </div>
                  <div className='things-to-do-list-item-links'>
                    <a href="https://blissandbone.sendbirdie.com/r/chandlerandanna" target="_blank" rel="noopener noreferrer">Cash registry</a>
                  </div>
                </div>
                {registries.map((registry) => (
                  <div key={registry.company} className='things-to-do-list-item'>
                    <p className='things-to-do-list-item-title'>{registry.company}</p>
                    <div className='things-to-do-list-item-links'>
                      {registry.info}
                    </div>
                    <div className='things-to-do-list-item-links'>
                      <a href={registry.website} target="_blank" rel="noopener noreferrer">Registry</a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='centered-box'>
        { utils.displayCheckerboard(20, 42, ['blue', 'ivory']) }
      </div>
    </div>
  );
}

export default Registry;
